<template>
  <div class="container no-padding-container text-gray-600">
    <div class="px-5">
      <div class="pt-5 md:pt-12">
        <h1 class="ota-title mb-3 text-center md:mb-10" v-text="$t('TermsAndConditions.Content.Title')" />
      </div>
      <TermsAndConditionsComponent />
    </div>
  </div>
</template>

<script>
import TermsAndConditionsComponent from '@/components/TermsAndConditionsComponent'

export default {
  name: 'TermsAndConditions',
  layout: 'homepage',
  components: { TermsAndConditionsComponent },
  head () {
    return {
      title: this.$t('TermsAndConditions.PageTitle'),
      meta: [
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.$t('TermsAndConditions.Description')
        }
      ]
    }
  }
}
</script>

<style lang="postcss" scoped>
.product-accordion {
  >>> b {
    @apply font-extrabold;
  }

  >>> .ota-p18 {
    font-size: 1.5rem;
  }
}

.right-flex {
  max-width: 75rem;
}
</style>
